//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import loadmore from '@/components/ui/loadmore';
import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';

export default {
    components: {loadmore,cardbox,navbar},
    data(){
        return {
            listData: {
                current_page: 1,
                total: 0,
                per_page: 50,
                data: [],
            },
            typeData: [
                {name: 'INTEGRAL_REG', value: 1, text:'注册赠送积分', type: 1},
                {name: 'INTEGRAL_LOGIN', value: 2, text:'登录赠送积分', type: 1},
                {name: 'INTEGRAL_RECOM', value: 3, text:'推荐赠送积分', type: 1},
                {name: 'INTEGRAL_BUY', value: 4, text:'购买赠送积分', type: 1},
                {name: 'INTEGRAL_SELLER', value: 5, text:'抵扣删减积分', type: 2},
                {name: 'INTEGRAL_ADD', value: 6, text:'管理员增加积分', type: 1},
                {name: 'INTEGRAL_SUB', value: 7, text:'管理员减少积分', type: 2},
                {name: 'INTEGRAL_EGG', value: 8, text:'砸金蛋删减积分', type: 2},
                {name: 'INTEGRAL_GOODS', value: 9, text:'兑换礼品删减积分', type: 2},
            ]
        }
    },
    filters: {
        timer: function(value){
            if(!value) return '';
            let date = new Date(value*1000);
            return common.formatDate(date);
        }
    },
    methods:{

        // 查询列表
        queryFeedback(){

            const opts = {
                url: api.myIntegral,
                data: {
                    page:1,
                    size:100,
                },
                type: 'get'
            }
            common.query(opts).then(res=>{
                this.listData = res.data;
            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){

        this.queryFeedback();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/integralList.vue